module.exports = __webpack_public_path__ + "static/media/Boots.svg";